// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__uyxo5","question":"styles_question__Ca9NV","description":"styles_description__1DnmK"};